module.exports = __webpack_public_path__ + "static/img/15.c1af524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/15.png
// module id = cH/8
// module chunks = 0